import {useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {
    archiveBusinessService,
    createBusinessServiceCategory,
    updateBusinessServiceCategory,
} from "app/redux/businessServicesSlice";
import {RootState} from "app/redux/store";
import {useCatalog} from "../../useCatalog";
import {createProductCategory, deleteProductCategory, updateProductCategory} from "../../../redux/productSlice"; // adjust to your store type

type CategoryType = "service" | "product";

interface ModalCategory {
    id?: number;
    name: string;
}

export const useManageCategories = (onUpdate: (categories: any) => void) => {
    const dispatch = useDispatch();

    // const {categories, setProductCategories} = useCatalog()


    /** Add category */
    const addCategory = async (type: CategoryType, name: string) => {
        if (!name.trim()) return;

        if (type === "product") {
            try {
                await dispatch(createProductCategory({name}) as any).unwrap();
                toast.success(`Product Category "${name}" created successfully`);
            } catch (err: any) {
                console.error(err);

                toast.error(err?.data?.error ?? "Failed to create product category");
            }
        }


        if (type === "service") {
            try {
                await dispatch(createBusinessServiceCategory({name}) as any).unwrap();
                toast.success(`Service Category "${name}" created successfully`);
            } catch (err:any) {
                console.error(err);
                toast.error(err?.data?.error ?? "Failed to create service category");

            }
        }
    };

    /** Edit category */
    const editCategory = async (type: CategoryType, oldCategory: ModalCategory, newName: string) => {
        if (!newName.trim() || oldCategory.name === newName) return;

        if (type === "product" && oldCategory.id) {


            try {
                await dispatch(
                    updateProductCategory({categoryId:oldCategory.id, data: {name:newName}}) as any
                ).unwrap();
                toast.success("Product category updated successfully");
            } catch (err:any) {
                console.error(err);
                toast.error(err?.data?.error  ?? "Failed to update product category");
            }

        }


        if (type === "service" && oldCategory.id) {
            try {
                await dispatch(
                    updateBusinessServiceCategory({id: oldCategory.id, name: newName}) as any
                ).unwrap();
                toast.success("Service category updated successfully");
            } catch (err:any) {
                console.error(err);
                toast.error(err?.data?.error ?? "Failed to update service category");
            }
        }
    };

    /** Delete/Archive category */
    const deleteCategory = async (type: CategoryType, category: ModalCategory) => {


        if (!category.id) return
        const shouldArchive = window.confirm(
            `Are you sure you want to delete all services in the ${category.name} category?`
        );
        if (!shouldArchive) return;

        if (type === "product") {
            try {
                await dispatch(deleteProductCategory({id: category.id}) as any).unwrap();
                toast.success("Category archived successfully");
            } catch (err) {
                console.error(err);
                toast.error("Failed to archive category");
            }

            // setProductCategories(prev => prev.filter(c => c.id !== category.id));
            // toast.success("Product category deleted successfully");
            // return;
        }

        if (type === "service") {


            try {
                await dispatch(archiveBusinessService({id: category.id}) as any).unwrap();
                toast.success("Service category archived successfully");

            } catch (err) {
                console.error(err);
                toast.error("Failed to archive service category");
            }
        }
    };

    /** Merge categories for the modal */

    /** Save all (pass back to parent if needed) */
    const saveChanges = () => {
        // onUpdate(categories);
    };

    return {
        // categories,
        addCategory,
        editCategory,
        deleteCategory,
        saveChanges,
    };
};
